import { api } from './api';

export type ReferralLink = {
  id: number;
  token: string;
  url: string;
  name: string;
};

export type SendReferralLinkPayload = {
  email: string;
};

export const referralApi = api.injectEndpoints({
  endpoints: builder => ({
    getReferralLink: builder.query<ReferralLink | null, void>({
      queryFn: async (_arg, _api, _extraOptions, fetchWithBQ) => {
        const result = await fetchWithBQ({
          url: `${process.env.REACT_APP_API_URL}/users/referral/link/`,
        });

        if (result.error) {
          const status = (result.error as { status?: number }).status;
          if (status === 404) {
            return { data: null };
          }
          return { error: result.error };
        }

        return { data: result.data as ReferralLink };
      },
      providesTags: ['ReferralLink'],
    }),
    createReferralLink: builder.mutation<ReferralLink, void>({
      query: () => ({
        url: `${process.env.REACT_APP_API_URL}/users/referral/link/`,
        method: 'POST',
      }),
      invalidatesTags: ['ReferralLink'],
    }),
    sendReferralLink: builder.mutation<void, SendReferralLinkPayload>({
      query: body => ({
        url: `${process.env.REACT_APP_API_URL}/users/referral/link/send/`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetReferralLinkQuery,
  useCreateReferralLinkMutation,
  useSendReferralLinkMutation,
} = referralApi;
